import React from 'react'
import './SplashPage.scss'
import Navigation from './Navigation'

const SplashPage: React.FC = () => {
  return (
    <div className="splash-container">
      <img src="/splash.png" alt="Ford Air Tour Splash" className="splash-image" />
      <h1 className="splash-title">Ford Air Tour</h1>
      <p className="splash-description">
        In 1925, the Ford Reliability Air Tour set out to prove that airplanes could be more than daring stunts—they could be dependable, everyday machines for travel and commerce. A hundred years on, its echoes remind us how innovation often begins as a question of trust, inviting those who wonder to step closer and see where the story leads.
      </p>
      <Navigation />
    </div>
  )
}

export default SplashPage